export default __webpack_public_path__ + "985d4b3d14a92658a2f72e68065edc20.svg";